module.exports = __webpack_public_path__ + "img/character-1.1a5d4c7d.svg";